import styled from 'styled-components';

export const Message = styled.p`
    text-align: center;
`